import type { TFunction } from 'i18next'
import { z } from 'zod'

import { HEX_COLOR_REGEX } from '../../../../../constants/hexColorRegex'
import type { LogoAndBrandingSettingsFormSchema } from '../types/logoAndBrandingSettingsFormSchema'

export const getLogoAndBrandingSettingsFormSchema = (t: TFunction): LogoAndBrandingSettingsFormSchema => {
  return z.object({
    logoId: z.string().nullable(),
    logoUrl: z.string().nullable().optional(),
    shouldApplyTemplateColorToColumnHeaders: z.boolean(),
    shouldApplyTemplateColorToDividers: z.boolean(),
    shouldApplyTemplateColorToHeader: z.boolean(),
    shouldApplyTemplateColorToTotal: z.boolean(),
    templateColor: z
      .string()
      .regex(HEX_COLOR_REGEX, t('settings.organization.external_invoice.validation.invalid_hex_color')),
    templateFont: z.string(),
  })
}
